/* import __COLOCATED_TEMPLATE__ from './phone.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let SecureContactModalEnrollPhoneComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class SecureContactModalEnrollPhoneComponent extends Component {
  get canRequestSignInCode() {
    return this.phoneNumberValid;
  }
  get countryCodeToT() {
    const tKeyPrefix = this.args.tPrefix + 'phone_number.country_code.';
    const map = {};
    this.multipassfeClient.constants.COUNTRY_CODES.SMS.forEach(c => map[c] = tKeyPrefix + c);
    return map;
  }
  get invalidPhoneErrorTLabel() {
    return 'secure_contact_modals.enroll.phone.errors.invalid_phone';
  }
  get temporaryLockoutErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.temporary_lockout';
  }
  get secureContactAliasConflictErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.secure_contact_alias_conflict';
  }
  get unknownErrorTLabel() {
    return 'secure_contact_modals.enroll.phone.errors.unknown';
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor3, this);
    _initializerDefineProperty(this, "loading", _descriptor4, this);
    _initializerDefineProperty(this, "phoneError", _descriptor5, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor6, this);
    _initializerDefineProperty(this, "phoneNumberValid", _descriptor7, this);
    _initializerDefineProperty(this, "smsBlockedManualOptInModalOpen", _descriptor8, this);
    _defineProperty(this, "validating", false);
  }
  handleMultipassError(error) {
    switch (error) {
      case 'BLOCKED_SMS_NUMBER':
        this.smsBlockedManualOptInModalOpen = true;
        break;
      case 'SECURE_CONTACT_ALIAS_CONFLICT':
        this.phoneError = this.intl.t(this.args.tPrefix + this.secureContactAliasConflictErrorTLabel);
        break;
      case 'TEMPORARY_LOCKOUT':
        this.phoneError = this.intl.t(this.args.tPrefix + this.temporaryLockoutErrorTLabel);
        break;
      default:
        this.phoneError = this.intl.t(this.args.tPrefix + this.unknownErrorTLabel);
    }
  }
  onPhoneInvalid() {
    this.phoneNumber = '';
    this.phoneNumberValid = false;
  }
  onPhoneValid({
    number,
    national
  }) {
    this.phoneNumber = number;
    this.phoneNumberValid = true;
    this.args.setPhoneNumber(this.phoneNumber);
    this.args.setPhoneNumberDisplay(national);
  }
  handleSmsBlockedManualOptInModalClose() {
    this.smsBlockedManualOptInModalOpen = false;
  }
  async sendPhoneSecureContactCodeDebounced() {
    debounce(this, this.sendPhoneSecureContactCode, 500, true);
  }
  async sendPhoneSecureContactCode() {
    if (!this.canRequestSignInCode) {
      this.phoneError = this.intl.t(this.args.tPrefix + this.invalidPhoneErrorTLabel);
      return;
    }
    try {
      this.validating = true;
      this.loading = true;
      await this.multipassfeClient.sendPhoneSecureContactCode(this.phoneNumber);
      this.args.next();
    } catch (e) {
      this.logger.error('Error enrolling secure contact phone number', e.message);
      this.handleMultipassError(e.message);
    } finally {
      this.loading = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "phoneError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberValid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "smsBlockedManualOptInModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onPhoneInvalid", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPhoneInvalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPhoneValid", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPhoneValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSmsBlockedManualOptInModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSmsBlockedManualOptInModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendPhoneSecureContactCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendPhoneSecureContactCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendPhoneSecureContactCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendPhoneSecureContactCode"), _class.prototype), _class);
export { SecureContactModalEnrollPhoneComponent as default };